// Helper de búsqueda inteligente multi-campo en conversaciones.
// Matchea contra nombre cliente · teléfono (normalizado) · email · identifier
// · usernames de redes sociales · id de conversación.

function normalizeDigits(str) {
  return String(str || '').replace(/\D+/g, '');
}

// Quita tildes/acentos para que la búsqueda local encuentre con o sin tilde
// (ej. "fidelina" → "Fidélina"). Equivale al unaccent() del backend (Victor
// 2026-06-03).
function stripAccents(str) {
  // ̀-ͯ = marcas diacríticas combinantes (tildes, acentos).
  return String(str || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

export function conversationMatchesSearch(conversation, rawQuery) {
  const raw = String(rawQuery || '').trim();
  if (!raw) return true;
  const q = stripAccents(raw.toLowerCase());
  // El "@" inicial es decorativo (usuario de red) · matchea contra handles sin él.
  const qNoAt = q.startsWith('@') ? q.slice(1) : q;

  const sender = conversation?.meta?.sender || {};
  const aa = sender.additional_attributes || {};
  const sp = aa.social_profiles || {};

  const stringCandidates = [
    sender.name,
    sender.email,
    sender.identifier,
    sender.thumbnail,
    sp.instagram,
    sp.facebook,
    sp.twitter,
    sp.linkedin,
    sp.github,
    aa.social_instagram_user_name,
    String(conversation?.id || ''),
  ].filter(Boolean);

  if (
    stringCandidates.some(c =>
      stripAccents(String(c).toLowerCase()).includes(qNoAt)
    )
  )
    return true;

  // Match por teléfono · normaliza dígitos en query y candidato
  const qDigits = normalizeDigits(q);
  if (qDigits.length >= 3) {
    const phoneDigits = normalizeDigits(sender.phone_number);
    if (phoneDigits.includes(qDigits)) return true;
  }

  return false;
}

// Detecta de qué tipo es la búsqueda para mostrar el chip "Buscando por ..."
// junto al input. NO afecta la lógica de match (todo está mezclado en backend);
// solo es UX para que el agente sepa qué está buscando.
export function detectSearchType(rawQuery) {
  const raw = String(rawQuery || '').trim();
  if (!raw) return null;
  if (raw.startsWith('@')) return 'social';
  // Heurística teléfono: ≥3 dígitos y mayoría de chars son dígitos/separadores
  const digits = raw.replace(/\D+/g, '');
  if (digits.length >= 3 && /^[\d\s+()-]+$/.test(raw)) return 'phone';
  if (raw.includes('@') && raw.includes('.')) return 'email';
  return 'name';
}

export const SEARCH_TYPE_LABEL = {
  social: '📷 Usuario de red',
  phone: '📞 Teléfono',
  email: '✉ Email',
  name: '👤 Nombre',
};

export default { conversationMatchesSearch };
